<template>
  <div class="home">
    <h1>{{msg}}</h1>
    <section v-for="section in sections" v-bind:key="section.id">
        <div class="col1" >
            <h3>{{section.id}}</h3>
            <ul class="inline">
                <li v-for="news in section.content" v-bind:key="news.id">{{news.title}}</li>
            </ul>
        </div>
    </section>
  </div>
</template>

<script>
const fb = require('../firebaseConfig.js')
export default {
  name: "Home",
  data() {
    return {
      msg: "Home !!!!!!!",
      sections: [],

    };
  },
  created() {
    
      this._getSections();
    
  },
   methods: {
        _getSections(){
           var _this = this;
        //    fb.db.collection("pages/home/sections")
        //     .onSnapshot(function(querySnapshot) {
        //         _this.sections = [];
        //         querySnapshot.forEach(function(doc) {
        //             let object=doc.data()
        //             object.id = doc.id
        //             object.content=[]
        //             _this._getContents(object)
        //             _this.sections.push(object);
        //         });
        //     });
        
        },
        _getContents(section){
            // if(section.content==null || section.content==undefined)
            //     section.content=[];
            // fb.db.collection("pages/home/sections/"+section.id+"/content").onSnapshot(function(querySnapshot) {
            //     section.content=[];
            //     querySnapshot.forEach(function(doc) {
            //         let object=doc.data()
            //         object.id = doc.id
            //         section.content.push(object);
            //     });
            // });

        }
    },
  
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
